const constants = {
    // 文件操作
    FILE_GetFile: '/file/file/',
    FILE_GetFileWithType: '/file/fileWithType/',
    FILE_GetVideo: '/file/video/',
    FILE_UploadFile: '/file/uploadFile.action',
    // 读取内容管理-配置
    API_GetCmsSetting: '/anon/getCmsSetting.action',
    // 获取启用的栏目列表
    API_GetCmsColumnList: '/anon/getCmsColumnList.action',
    // 获取标签列表
    API_GetCmsTagList: '/anon/getCmsTagList.action',
    // 获取文档列表
    API_GetCmsDocList: '/anon/getCmsDocList.action',
    // 根据sid获取文档
    API_GetCmsDoc4AnonBySid: '/anon/getCmsDoc4AnonBySid.action',
    // 根据静态URL获取文档
    API_GetCmsDoc4AnonByStaticUrl: '/anon/getCmsDoc4AnonByStaticUrl.action',
    // 获取微信登录配置
    API_GetWxOpenSetting: '/anon/getWxOpenSetting.action',
    // 根据token获取注册用户信息
    API_GetSysRegUser4AutoLogin: '/anon/getSysRegUser4AutoLogin.action',
    // 发表评论
    API_SaveDocComment: '/anon/saveDocComment.action',
    // 根据doc_sid获取评论（分页）
    API_FindCmsDocComments4AnonByDocSid: '/anon/findCmsDocComments4AnonByDocSid.action',
    // 保存文章互动（点赞、踩、收藏）
    API_SaveCmsDocAction4Anon: '/anon/saveCmsDocAction4Anon.action',
    // 模拟微信登录
    API_SimulateWxLogin: '/anon/simulateWxLogin.action',
    // 注册用户
    API_RegUser: '/anon/regUser.action',
    // 保存注册用户
    API_SaveSysRegUser4Anon: '/anon/saveSysRegUser4Anon.action',
    // 修改注册用户密码
    API_ChangeRegUserPwd: '/anon/changeRegUserPwd.action',
    // 注册用户登录
    API_RegUserLogin: '/anon/regUserLogin.action',

    // 微信公众号
    API_GetOpenId: '/anon/getOpenId.action',
    // 微信小程序登录
    API_LoginByXcx: '/anon/loginByXcx.action',
    // 手动点击（检验是否机器爬虫）
    API_ManualTap: '/anon/manualTap.action',
};
export default constants;
